import { useCartStore } from '~/stores/cart'
import { LIMITED_ACCESS_SEGMENT } from '~/utils/categoryRoutes'
import { PORTAL_ROOT } from '~/utils/portalRoutes'
import { HOME_ROOT } from '~/utils/routes'
import { getLanguagePathFromRoute } from '~/utils/locale'

const limitedAccessMarker = `${LIMITED_ACCESS_SEGMENT}/`

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const promotionName = to.path.split(limitedAccessMarker)[1]?.toLowerCase()
  if (!promotionName) {
    return
  }

  const cartStore = useCartStore()
  const { isAgent, isDemo } = useSAuth()
  if (!isAgent.value && !cartStore.cart.id) {
    await cartStore.fetchCart()
  }
  const hasPromotionAccess = isAgent.value || (cartStore.summary.promotionSummary?.some(promotion =>
    promotion.limitedAccessPromotionSummary?.categoryPageRoute
      ?.toLowerCase()
      .includes(promotionName)
  ) ?? false)

  if (hasPromotionAccess) {
    return
  }

  const languagePath = getLanguagePathFromRoute(to.path)
  const redirectPath = isDemo.value
    ? `${languagePath}${PORTAL_ROOT}`
    : languagePath || HOME_ROOT

  return navigateTo(redirectPath)
})